import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import Button from '../../shared/Button';

export const LayoutManagementActions = ({ selectedLayout, addLayout, onCancel, onSave }) => {
  const actions = [];

  if (!addLayout && selectedLayout) {
    actions.push(
      <Link key="CopyLayoutLink" kind="primary" to={`/layouts/copy/${selectedLayout.id}`}>
        <Button kind="primary" className="ml-3">
          Copy Layout
        </Button>
      </Link>,
    );
  }

  if (!addLayout) {
    actions.push(
      <Link key="AddLayoutLink" to="/layouts/add">
        <Button kind="primary" className="ml-3">
          Add Layout
        </Button>
      </Link>,
    );
  }

  if (selectedLayout || addLayout) {
    actions.push(
      <Button onClick={onCancel} key="CancelButton" kind="primary" className="ml-3">
        Cancel
      </Button>,
    );
    actions.push(
      <Button onClick={onSave} key="SaveButton" kind="primary" className="ml-3">
        Save
      </Button>,
    );
  }

  return <Fragment>{actions}</Fragment>;
};

LayoutManagementActions.propTypes = {
  selectedLayout: PropTypes.object,
  addLayout: PropTypes.bool,
  onCancel: PropTypes.func,
  onSave: PropTypes.func,
  isValidForm: PropTypes.bool,
};



// WEBPACK FOOTER //
// src/components/LayoutManagement/LayoutManagementActions/index.jsx